import axios from 'axios';
import xhrRoutes from '../routes/xhr';
import stringifyObject from '../../helpers/stringify-object';
import Translator from '../translator';
import messageLikes from './message-like';

const fn = {
  classMessageDisabled: 'card__like__icon--disabled',
  classMessageUnlike: 'card__like__icon--liked',
  classMessageSelector: 'js-message-unlike',
  init: () => {
    const messageUnlikes = document.querySelectorAll('.js-message-unlike');

    if (!messageUnlikes.length) {
      return;
    }

    [].forEach.call(messageUnlikes, (messageUnlike) => {
      messageUnlike.addEventListener('click', fn.eventListener);
    });
  },
  showNotification: (type, message) => {
    const notification = document.createElement('div');
    notification.classList.add('notification');
    notification.classList.add(`notification--${type}`);
    notification.innerHTML = message;
    document.body.appendChild(notification);
  },
  eventListener: (event) => {
    const messageUnlike = event.target;

    if (messageUnlike.classList.contains(fn.classMessageDisabled)) {
      return;
    }

    const messageId = messageUnlike.getAttribute('data-message-id');

    messageUnlike.classList.add(fn.classMessageDisabled);

    const route = xhrRoutes.comment.unlikeMessage;
    route.params.message_id = messageId;

    axios.post(route.url, stringifyObject(route.params))
      .then((response) => {
        if (response.data.status === 'fail') {
          fn.showNotification('error', Translator.trans('api.error.fail'));
          messageUnlike.classList.remove(fn.classMessageDisabled);
        } else {
          fn.showNotification('success', Translator.trans('api.community.message.unliked'));
          messageUnlike.classList.remove(fn.classMessageDisabled);

          messageUnlike.classList.remove(fn.classMessageUnlike);
          messageUnlike.classList.remove(fn.classMessageSelector);

          messageUnlike.classList.add(messageLikes.classMessageLike);
          messageUnlike.classList.add(messageLikes.classMessageSelector);

          messageLikes.init();
          messageUnlike.removeEventListener('click', fn.eventListener);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .then(() => {
      });
  },
};

export default fn;
